var getRequestWithCallback = function(method, url, headers, data, callback, responseType) {
  var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = callback.bind(this);
  xhttp.open(method, url, true);
  if (responseType) {
    xhttp.responseType = responseType;
  }
  Object.keys(headers).forEach(function(key) {
    xhttp.setRequestHeader(key, headers[key]);
  });
  if (data) {
    xhttp.send(data);
  } else {
    xhttp.send();
  }
  return xhttp;
}

export default getRequestWithCallback;